import { SetupAuth } from "../../client";
import { displayError, displaySuccess, displayWarning } from "../../utils/messageToast";

export type PlanTabulationPayload = {
  id: string;
  skillName: string;
  tabName?: string;
};


/** Retorna `true` se o .xlsx foi gerado e o download iniciado. */
export const generatePlan = async (
  tabulations: PlanTabulationPayload[],
  workbookName: string,
  ambient: string,
  authorization: string,
  source: "force" | "rc",
): Promise<boolean> => {
  if (!tabulations.length) {
    displayWarning("Selecione ao menos uma tabulação.");
    return false;
  }
  const name = workbookName.trim();
  if (!name) {
    displayWarning("Informe o nome do arquivo da planilha.");
    return false;
  }
  try {
    const api = SetupAuth(authorization);
    const response = await api.post(
      `/create-plan?ambient=${encodeURIComponent(
        ambient
      )}&source=${encodeURIComponent(source)}`,
      { tabulations, workbookName: name },
      { responseType: "blob" }
    );
    const disposition =
      (response.headers["content-disposition"] as string | undefined) ??
      (response.headers["Content-Disposition"] as string | undefined);
    const sourceLabel = source === "rc" ? "RC" : "Force";
    const ambientLabel = ambient === "prod" ? "PROD" : "HML";
    let filename = `Tabulações ${name} ${sourceLabel} ${ambientLabel}.xlsx`;
    const m = disposition?.match(
      /filename\*=UTF-8''([^;\n]+)|filename="([^"]+)"|filename=([^;\s]+)/i
    );
    const fromHeader = m?.[1]
      ? decodeURIComponent(m[1])
      : m?.[2] || m?.[3];
    if (fromHeader) {
      try {
        filename = fromHeader.replace(/^["']|["']$/g, "");
      } catch {
        /* usar nome do input */
      }
    }

    const blob = response.data as Blob;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    displaySuccess("Planilha gerada com sucesso!");
    return true;
  } catch (e: unknown) {
    const err = e as { response?: { data?: Blob } };
    const data = err.response?.data;
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const j = JSON.parse(text) as { error?: string };
        displayError(j.error ?? "Erro ao gerar planilha.");
      } catch {
        displayError("Erro ao gerar planilha.");
      }
      return false;
    }
    displayError("Erro ao gerar planilha.");
    return false;
  }
};
